import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// Page Impression
// Tracks the first navigation to the page

import track from './track';
var attemptsRemaining = 60;

// Record the page load performance
function record() {
  var _window$performance, _window$performance2;
  var diff = 0;

  // Use the navigation entry if available
  if ((_window$performance = window.performance) !== null && _window$performance !== void 0 && _window$performance.getEntriesByType) {
    var _window$performance$g = window.performance.getEntriesByType('navigation'),
      _window$performance$g2 = _slicedToArray(_window$performance$g, 1),
      entry = _window$performance$g2[0];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    diff = entry.loadEventEnd;
  }

  // Fallback to timing if navigation entry is not available
  else if ((_window$performance2 = window.performance) !== null && _window$performance2 !== void 0 && _window$performance2.timing) {
    var _window$performance$t = window.performance.timing,
      navigationStart = _window$performance$t.navigationStart,
      loadEventEnd = _window$performance$t.loadEventEnd;
    diff = loadEventEnd - navigationStart;
  }
  if (diff > 0) {
    track('performance', 'pageload', diff);
  }
  // Try again
  else if (attemptsRemaining--) {
    // Try again in 1 second
    setTimeout(record, 1000);
  }
}
try {
  // Trigger
  record();
} catch (_unused) {
  // Continue
}